import { useEffect, useState } from "react"
import { RadioButtonList } from "src/@/components/shared/RadioButtonList"
import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import v2_actionCriarCalendario from "src/actions/v2/calendario/v2_actionCriarCalendario"
import Iconify from "src/components/Iconify"

export function ModalNovoCalendario({
  user,
  isEdit,
  onCallback
}) {
  const [open, setOpen] = useState(false)
  const [source, setSource] = useState('lais');
  const [name, setName] = useState('');


  async function handleCreateCalendar() {
    try {
      let data = {
        scope: {
          name:name, 
          source:source
        }
      }
      const response = await v2_actionCriarCalendario(user.clienteId, data)
      if(response.status === 200) {
        setOpen(false);
        setName('');
        setSource('lais');
        onCallback(response.data.data._id)

      }
    } catch (error) {
        console.log(error)
    }
}

   useEffect(() => {
    return () => {
      setName('');
      setSource('lais');
    }
   }, [])




  return (
    <Dialog open={open} onOpenChange={setOpen} >
      <DialogTrigger asChild>
        <Button
          className="h-full flex flex-col gap-2 rounded"
          variant="outline"
          onClick={() => setOpen(true)}
        >
          <Iconify icon="typcn:plus" />
          Novo Calendário
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Editar" : "Criar"} calendário</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div>
            <label>Nome</label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              id="name"
              className="col-span-3"
            />
          </div>

          <div>
            <label>Fonte</label>

          <RadioButtonList
            title="Fonte"
            selected={source}
            options={[
              {
                value: 'lais',
                label: 'Lais',
                // icon: 'ic:round-account-box',
              },
              {
                value: 'google',
                label: 'Google calendário',
                // icon: 'ic:round-vpn-key',
              },
            ]}
            onChange={(value) => setSource(value)}
          />
          </div>

        </div>
        <DialogFooter>
          <Button onClick={handleCreateCalendar}>{isEdit ? "Editar" : "Criar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
